import { BindingError } from "../../BindingError.js";
import { PRIMARY_KEY_NAME } from "../../bindingTypes.js";
import { EventManager } from "../EventManager.js";
import { OperationsHelpers } from "./OperationsHelpers.js";
import { EventListenersStore } from "../../treeParameters/EventListenersStore.js";
import { ClientGeneratedUuid } from "../../accessorTree/RuntimeId.js";
import { StateIterator } from "../state/StateIterator.js";
import { getEntityMarker } from "../state/getEntityMarker.js";
import { FieldAccessor } from "../../accessors/FieldAccessor.js";
class FieldOperations {
  constructor(accessorErrorManager, eventManager, stateInitializer, treeStore) {
    this.accessorErrorManager = accessorErrorManager;
    this.eventManager = eventManager;
    this.stateInitializer = stateInitializer;
    this.treeStore = treeStore;
  }
  addError(fieldState, error) {
    return this.accessorErrorManager.addError(fieldState, error);
  }
  clearErrors(fieldState) {
    return this.accessorErrorManager.clearErrorsByState(fieldState);
  }
  addEventListener(state, event, listener) {
    if (!state.eventListeners) {
      state.eventListeners = new EventListenersStore();
    }
    return state.eventListeners.add(event, listener);
  }
  updateValue(fieldState, newValue, { agent = FieldAccessor.userAgent } = {}) {
    this.eventManager.syncOperation(() => {
      const { placeholderName, parent } = fieldState;
      if (placeholderName === PRIMARY_KEY_NAME) {
        const entity = fieldState.parent.entity;
        if (typeof newValue !== "string") {
          throw new BindingError();
        }
        OperationsHelpers.changeEntityId(
          this.treeStore,
          this.eventManager,
          this.stateInitializer,
          entity,
          new ClientGeneratedUuid(newValue)
        );
      }
      for (const field of StateIterator.eachSiblingRealmChild(this.treeStore, fieldState)) {
        if (newValue === field.value) {
          continue;
        }
        if (field.touchLog === void 0) {
          field.touchLog = /* @__PURE__ */ new Set();
        }
        field.touchLog.add(agent);
        field.value = newValue;
        const resolvedValue = field.fieldMarker.defaultValue === void 0 ? newValue : newValue === null ? field.fieldMarker.defaultValue : newValue;
        const normalizedPersistedValue = field.persistedValue === void 0 ? null : field.persistedValue;
        const hadUnpersistedChangesBefore = field.hasUnpersistedChanges;
        const hasUnpersistedChangesNow = resolvedValue !== normalizedPersistedValue;
        field.hasUnpersistedChanges = hasUnpersistedChangesNow;
        const shouldInfluenceUpdateCount = !getEntityMarker(parent).fields.hasAtLeastOneBearingField || !field.fieldMarker.isNonbearing || field.persistedValue !== void 0;
        let changesDelta = EventManager.NO_CHANGES_DIFFERENCE;
        if (shouldInfluenceUpdateCount) {
          if (!hadUnpersistedChangesBefore && hasUnpersistedChangesNow) {
            changesDelta++;
          } else if (hadUnpersistedChangesBefore && !hasUnpersistedChangesNow) {
            changesDelta--;
          }
        }
        this.eventManager.registerJustUpdated(field, changesDelta);
      }
    });
  }
}
export {
  FieldOperations
};
//# sourceMappingURL=FieldOperations.js.map
